import {ReduceStore} from 'flux/utils';
import Immutable from 'immutable';


import {MessageAction, UserAction, DesignerAction, RedeemAction, StockAction} from 'AppAction';

import Dispatcher from 'service/Dispatcher';
import SessionStore from 'stores/SessionStore';

const AlertMessage = new Immutable.Record({
			message: null,
			type: null,
			alertAction: null,
			actionData: null
});

class MessageStore extends ReduceStore {
	constructor() {
		super(Dispatcher);
	}

	getInitialState() {
		return new AlertMessage();
	}

	getAlertMessage() {
		return this.getState().message === null? null: this.getState();
	}

	reduce(state, action) {
		Dispatcher.waitFor([SessionStore.getDispatchToken()]);
		switch(action.type) {
			case MessageAction.MESSAGE:
				const message = action.message;

				if(typeof message === 'string')
					return new AlertMessage({message: message, type: "INFO"});

				return new AlertMessage(message);

			case MessageAction.CLEAR_MESSAGE:
				return new AlertMessage();

			case UserAction.LOGOUT:
				return state;
			case MessageAction.MESSAGE_WITH_ACTION:
				return new AlertMessage(action.message);

			case DesignerAction.LOAD_CACHABLE_SALES_TARGET:
				return state;

			case RedeemAction.LOAD_REDEEM_HISTORY:
				return state;

			case DesignerAction.LOAD_BALANCE:
				return state;
			
			case StockAction.LOAD_OWNER_STOCKS:
				return state;

			case StockAction.CLEAR_OWNER_STOCKS:
				return state;
			
			case StockAction.LOAD_STOCK_HISTORY:
				return state;

			default:
				break;
		}

		//for all other action type, clear the alert message if any
		if(action.type)
			return new AlertMessage();

		return state;
	}
}


export default new MessageStore();


// WEBPACK FOOTER //
// ./src/stores/MessageStore.js